import React, { ReactElement } from 'react';
import { Typography } from 'antd';

import { ContractFormDescriptionStyled } from 'pricing/components/contract/contractFormDescription/ContractFormDescription.styled';
import { Contract } from 'pricing/types';
import { Nullable } from 'types';

const { Text } = Typography;

interface ContractFormDescriptionProps {
  contract: Nullable<Contract>;
}

interface ContractFormDescriptionItemProps {
  label: string;
  labelBold?: boolean;
  value: Nullable<string | number>;
  valueBold?: boolean;
}

function ContractFormDescriptionItem(
  props: ContractFormDescriptionItemProps,
): ReactElement {
  const { label, labelBold, value, valueBold } = props;
  return (
    <span>
      <Text className="contract-form-description-item-label" strong={labelBold}>
        {label}:
      </Text>
      <Text strong={valueBold}>{value}</Text>
    </span>
  );
}

function ContractFormDescription(props: ContractFormDescriptionProps): ReactElement {
  const { contract } = props;

  return (
    <ContractFormDescriptionStyled size={20}>
      <ContractFormDescriptionItem label="Contract ID" value={contract?.id} valueBold />
      <ContractFormDescriptionItem
        label="Total Listing Qty"
        value={contract?.totalQuantity}
        valueBold
      />
      <ContractFormDescriptionItem
        label="Created by"
        value={`${contract?.createdByUser?.firstName} 
        ${contract?.createdByUser?.lastName}`}
      />
    </ContractFormDescriptionStyled>
  );
}

export default ContractFormDescription;
